import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-edit-modal',
  templateUrl: './edit-modal.component.html',
})
export class EditModalComponent {

  @Input() item: any;
  @Input() saveButtonText = 'Save'
  @Input() showShipButton: boolean = false;
  @Input() showArrivedButton: boolean = false;
  @Input() showSaveButton: boolean = true;
  @Input() itemName: string;
  @Input() moduleName: string;
  @Input() isLoading: boolean;
  @Input() saveDisabled: boolean;
  @Output() saveClicked = new EventEmitter();
  @Output() cancelClicked = new EventEmitter();

  constructor() { }

  onSaveClicked() {
    this.saveClicked.emit();
  }

  onCancelClicked() {
    this.cancelClicked.emit();
  }


}
